import { render } from "./ItemManageBranchVariantForm.vue?vue&type=template&id=27211b9e"
import script from "./ItemManageBranchVariantForm.vue?vue&type=script&lang=js"
export * from "./ItemManageBranchVariantForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__